import React from 'react';
import { theme } from '../../../utils/theme';
import { addressListBoxStyle, addressListBoxFooterStyle } from '../styled';

export const AddressListBox = React.forwardRef<HTMLUListElement, React.HTMLAttributes<HTMLElement>>(
  function AddressListBox(props, ref) {
    const { children, ...other } = props;
    return (
      <ul ref={ref} {...other}>
        {children}
        {children && (Array.isArray(children) && children.length > 0) && (
          <li
            style={addressListBoxStyle}
            aria-disabled="true"
          >
            <img
              src={"assets/images/canadapost_addresscomplete.png"}
              style={{ height: 20, marginRight: 8 }}
            />
            <span style={addressListBoxFooterStyle}>
                Powered by Canada Post
            </span>
          </li>
        )}
      </ul>
    );
  }
);